import ChatItemButtons from "./ChatItemButtons";

/**
 * Un únic element (element de llista `<li>`) representant un xat a la barra lateral.
 * Gestiona estats visuals com `active`, `favourite`, `deleting` i inclou els botons d'acció.
 * 
 * @param {Object} props - Propietats d'aquest xat i les seves funcions callback.
 */
export default function ChatListItem({
  chat, isActive, deletingId, favFadingId, flashTitleId,
  favourites, openMenuId, setOpenMenuId,
  toggleFavourite, onSelect, onRename, onConfirmDelete,
}) {
  return (
    <li
      className={`chat-list-item${isActive ? ' active' : ''}${favourites.has(chat.id) ? ' favourite' : ''}${String(deletingId) === String(chat.id) ? ' deleting' : ''}${String(favFadingId) === String(chat.id) ? ' fav-fading' : ''}`}
      onClick={(e) => { e.preventDefault(); setOpenMenuId(null); onSelect(chat.id); }}
    >
      <a
        href={`/chat/${chat.id}`}
        className={`chat-list-title${flashTitleId === chat.id ? ' title-flash' : ''}`}
      >{chat.title}</a>
      <ChatItemButtons
        chat={chat}
        openMenuId={openMenuId}
        setOpenMenuId={setOpenMenuId}
        favourites={favourites}
        toggleFavourite={toggleFavourite}
        onRename={onRename}
        onDelete={onConfirmDelete}
      />
    </li>
  );
}
